export default {
      id: "ic-kuponlarim-green-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic-kuponlarim-green-usage",
      toString: function () {
        return this.url;
      }
    }